import {
  getExternalLink,
  isExternal,
  isRegistrationWithCustomDates,
  isWithoutRegistration,
  ticketedOrInitiallyTicketed,
} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {useEventDateInformation} from '../../../../../../commons/hooks/dates'
import {useSettings} from '../../../../../../commons/hooks/use-settings'
import settingsParams from '../../../../settingsParams'
import {useAppSelector} from '../../../hooks/runtime'
import {useVisibilityStyles} from '../../../hooks/use-visibility-styles'
import {getEvent} from '../../../selectors/event'
import {RegistrationButtonSkin} from '../../registration-buttons/registration-button-skin'
import {CustomDatesLabel} from '../custom-dates-label'
import {RegistrationButtonProps} from './interfaces'
import s from './registration-button.scss'
import {RegistrationUnavailableInfo, useRegistrationUnavailableConfig} from './registration-unavailable-info'

export const RegistrationButton = ({narrowerButton, onClick}: RegistrationButtonProps) => {
  const {t} = useTranslation()
  const {isMobile: mobile} = useEnvironment()
  const settings = useSettings()
  const config = useRegistrationUnavailableConfig()
  const {
    allBreakpoints: {isHeaderRegistrationButtonVisible},
  } = useVisibilityStyles()
  const event = useAppSelector(getEvent)
  const {formattedRegistrationEndDate: endDate} = useEventDateInformation(event.id)

  const commonClasses = classNames(s.container, {[s.mobile]: mobile})
  const ticketedOrInitiallyTicketedEvent = ticketedOrInitiallyTicketed(event)
  const rsvpButtonText = settings.getWithFallback(
    ticketedOrInitiallyTicketedEvent ? settingsParams.ticketedEventButtonText : settingsParams.rsvpEventButtonText,
    settingsParams.rsvpButtonText,
  )

  if (config) {
    return <RegistrationUnavailableInfo config={config} className={commonClasses} />
  }

  if (!isHeaderRegistrationButtonVisible() || isWithoutRegistration(event)) {
    return null
  }

  return (
    <div className={classNames(s.buttonContainer, commonClasses)}>
      <RegistrationButtonSkin
        dataHook={ticketedOrInitiallyTicketedEvent ? DH.HEADER_GET_TICKETS_BUTTON : DH.RSVP_BUTTON}
        text={rsvpButtonText}
        url={getExternalLink(event)}
        isExternalLink={isExternal(event)}
        narrowerButton={narrowerButton}
        onClick={onClick}
      />
      {isRegistrationWithCustomDates(event) && (
        <CustomDatesLabel dataHook={DH.RSVP_CLOSES_LABEL} text={t('registration.closesLabel', {date: endDate})} />
      )}
    </div>
  )
}
